import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const LogoWrapper = styled.div`
    margin-top: 3%;
    margin-bottom: 4%;
    cursor: pointer;

    img {
        width: 240px;
        height: auto;
    }
`;

interface ClickableLogoProps {
    src: string;
    alt: string;
}

const ClickableLogo: React.FC<ClickableLogoProps> = ({ src, alt }) => {
    const navigate = useNavigate();

    const handleLogoClick = () => {
        navigate('/login');
    };

    return (
        <LogoWrapper onClick={handleLogoClick}>
            <img src={src} alt={alt} />
        </LogoWrapper>
    );
};

export default ClickableLogo;
